/*
 * The Private License
 *
 * Copyright (c) 2023 Mahon Media LLC.
 */
import {useNotification} from "../contexts/NotificationContext";
import React, {useEffect, useState} from "react";
import Cookies from "js-cookie";
import {useHistory} from "react-router-dom/cjs/react-router-dom";
import {MAIN_ERROR_MESSAGES} from "../constants/errorMessages";
import {Box, Button, CircularProgress, InputAdornment, Paper, TextField, Typography} from "@mui/material";
import DatePicker from "react-datepicker";
import moment from "moment";
import 'moment-timezone';
import RatePlanTable from "./RatePlanTable";
import { getBackendBaseUrl } from "../utils/envUtils";

function Uc() {
  const {setIsOpen, setMessage, setIsFailed} = useNotification();
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [rids, setRids] = useState([]);
  const [current, setCurrent] = useState([]);
  const [counting, setCounting] = useState(false);
  const [checked, setChecked] = useState([]);
  const [have, setHave] = useState([]);
  const [udf, setUdf] = useState();
  const [fee, setFee] = useState();
  const [count, setCount] = useState();
  const [failed, setPrevFailed] = useState([]);
  const token = Cookies.get("crew_token");
  const ohip = Cookies.get('jwtToken');
  moment.tz.setDefault('America/Los_Angeles');
  const [start, setStart] = useState(new Date());
  const history = useHistory();
  useEffect(() => {
    if (!ohip || !token) {
      history.push("/");
      setIsOpen(true);
      setIsFailed(true);
      setMessage(MAIN_ERROR_MESSAGES.tokenExpired);
    }
  }, []);

  useEffect(() => {
    if (start) {
      console.log("Updated start date:", start);
    }
  }, [start]);

  const CustomInput = React.forwardRef(({value, onClick}, ref) => (
    <input
      ref={ref}
      value={value}
      onClick={onClick}
      style={{height: '40px', width: '200px', marginTop: '10px', textAlign: "center"}}
    />
  ));

  const query = async () => {
    const host = getBackendBaseUrl();
    setLoading(true);
    setFee();
    setCurrent([]);
    setChecked([]);
    setHave([]);
    const formatted = new Date(
      `${start.getFullYear()}-${String(101 + start.getMonth()).substr(1)}-${String(100 + start.getDate()).substr(1)}`
    ).toISOString().substring(0, 10);
    try {
      const response = await fetch(
        `${host}/api/v1/udf/grouped?env=beacon&launch=${formatted}`,
        {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error status: ${response.status}`);
      }
      const result = await response.json();
      setUdf(result);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setIsFailed(true);
      setMessage(`Failed to query reservations`);
      setIsOpen(true);
    }
  };

  const feeChange = (event) => {
    const value = event.target.value;
    // if (value === '' || (Number(value) >= 0 && !value.startsWith('-'))) {
      setFee(value);
    // }
  };

  const adjust = async () => {
    const host = getBackendBaseUrl();
    setUpdating(true);
    setCount();
    if (failed.length > 0) {
      console.log("STARTING from FAILED");
      console.log(failed);
      const rids = [];
      udf.udf.forEach((g) => {
        g.reservations.forEach((r) => {
          rids.push(r);
        })
      });
      setRids(rids);
      const queued = rids.filter((r) => !current.includes(r));
      console.log(queued);
      const process = Array.from(new Set([...failed, ...queued]));
      console.log("STARTING TO BE PROCESSED");
      console.log(process);
      try {
        for (const r of process) {
          const response = await fetch(
            `${host}/api/v1/udf/reservations`,
            {
              method: "PUT",
              body: JSON.stringify({
                  "rid": r,
                  "fee": fee,
                  "env": "beacon"
                }
              ),
              headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
              }
            }
          );
          if (!response.ok) {
            failed.push(r);
            setPrevFailed(failed);
            throw new Error(
              `${await response.json().then((err) => err.message)}`
            );
          }
          setIsFailed(false);
          setMessage(`Adjusted UDF fee in ${r} to $${fee}`);
          setIsOpen(true);
          current.push(r);
          setCurrent(current);
        }
        setUpdating(false);
        setCounting(true);
      } catch (error) {
        // setUpdating(false);
        setCounting(false);
        setIsFailed(true);
        setMessage(`Failed to adjust UDF fee: ${error}`);
        setIsOpen(true);
      }
    } else {
      const rids = [];
      udf.udf.forEach((g) => {
        g.reservations.forEach((r) => {
          rids.push(r);
        })
      });
      setRids(rids);
      const host = getBackendBaseUrl();
      try {
        for (const r of rids) {
          const response = await fetch(
            `${host}/api/v1/udf/reservations`,
            {
              method: "PUT",
              body: JSON.stringify({
                  "rid": r,
                  "fee": fee,
                  "env": "beacon"
                }
              ),
              headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
              }
            }
          );
          if (!response.ok) {
            failed.push(r);
            setPrevFailed(failed);
            throw new Error(
              `${await response.json().then((err) => err.message)}`
            );
          }
          setIsFailed(false);
          setMessage(`Adjusted UDF fee in ${r} to $${fee}`);
          setIsOpen(true);
          current.push(r);
          setCurrent(current);
        }
        setUpdating(false);
        // setCounting(true);
      } catch (error) {
        // setUpdating(false);
        setCounting(false);
        setIsFailed(true);
        setMessage(`Failed to adjust UDF fee: ${error}`);
        setIsOpen(true);
      }
    }
    setCounting(true);
    await countWithFee(rids, fee);
  };

  const countWithFee = async (rids, fee) => {
    let updatedHave = [];
    let updatedChecked = [];
    const host = getBackendBaseUrl();
    try {
      setRids(rids);
      for (const r of rids) {
        let rs = await fetch(
          `${host}/api/v1/udf/with-fee?fee=${fee}&rid=${r}&env=beacon`,
          {
            method: "GET",
            headers: {
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
        if (!rs.ok) {
          throw new Error(`HTTP error status: ${rs.status}`);
        }
        const response = await rs.json();
        if (response.hasFixedCharges) {
          updatedHave.push(response.hasFixedCharges);
        }
        updatedChecked.push(response.hasFixedCharges);
        setHave([...updatedHave]);
        setChecked([...updatedChecked]);
      }
      setCount(have.length);
    } catch (error) {
      setCounting(false);
      setIsFailed(true);
      setMessage(`Failed to count reservations with fixed charge=${fee}`);
      setIsOpen(true);
    }
  };

  return <>
    <Paper
      style={{
        padding: "20px",
        fontFamily: "Monaco, sans-serif",
        fontSize: "14px",
        flexDirection: "column",
        justifyContent: "flex-start",
        marginBottom: "40px"
      }}
    >
      <h2>UDF Conversion</h2>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100vh',
        marginTop: "-10px",
        gap: '20px',
        overflow: 'auto',
        maxHeight: '90vh',
        width: '100%',
      }}>
        Launch Date
        <DatePicker
          customInput={<CustomInput/>}
          selected={start}
          onChange={(date) => {
            const formattedDate = new Date(
              `${date.getFullYear()}-${String(101 + date.getMonth()).substr(1)}-${String(100 + date.getDate()).substr(1)}`
            ).toISOString().substring(0, 10);
            console.log(formattedDate);
            console.log(date);
            setStart(date);
          }}
        />
        <Button onClick={query}>
          Query
        </Button>
        {loading ? (
            <CircularProgress sx={{display: "block", m: "0 auto", mt: 5}}/>
          ) :
          <div
            style={{
              width: '100%',
              maxWidth: '1000px',
              margin: '0 auto',
              padding: '10px',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                gap: '20px',
                width: '100%',
                overflow: 'auto',
              }}
            >
              <div style={{flexGrow: 1}}> {}
                <RatePlanTable data={udf}/>
              </div>
              {udf !== undefined && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                  }}
                >
                  <TextField
                    sx={{
                      mt: 2,
                      maxWidth: '300px',
                      height: '40px',
                      "& input": {
                        padding: "0.6rem 0.8rem",
                        fontSize: '1.2rem',
                      },
                      marginLeft: "100px"
                    }}
                    label={"Adjust UDF Fee"}
                    // inputProps={{min: 0}}
                    onChange={feeChange}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    }}
                    type="number"
                    value={fee || ''}
                    required={true}
                  />
                  <Button
                    sx={{
                      mt: 2,
                      marginRight: "55px"
                    }}
                    disabled={fee === undefined || fee === ""}
                    onClick={adjust}
                  >
                    Adjust UDF Fee
                  </Button>
                  {updating && (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mt: 5,
                      }}
                    >
                      <Typography variant="body2" sx={{ mr: 6 }}>
                        Adjusting UDF Fee...
                      </Typography>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        <Typography variant="body2">
                          {`Adjusted: ${current.length}/${rids.length}`}
                        </Typography>
                        <Typography variant="body2">
                          {`Failed: ${failed.length}/${rids.length}`}
                        </Typography>
                      </Box>
                    </Box>
                  )}
                  {counting && failed.length === 0 && (
                    <Box>
                      {`So far found: ${have.length}. Checked ${checked.length}/${rids.length}`}
                    </Box>
                  )}
                  {count !== undefined && failed.length === 0 && `Found ${count} reservations with fee=${fee}`}
                </div>
              )}
            </div>
          </div>
        }
      </div>
    </Paper>
  </>
}

export default Uc;
